import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class PermisosService {
  private permisosState: string[] = undefined;

  setPermisos(permisos: string[]) {
    this.permisosState = permisos;
  }

  getPermisos(): string[] {
    if (this.permisosState == undefined) {
      this.permisosState = localStorage
        .getItem("permisos")
        .toLowerCase()
        .split("|");
    }
    return this.permisosState;
  }
}
